import { useState, useCallback, useEffect } from "react";
import { WorkService } from "../../../config/axiosUrl";
import { Checkbox } from "antd";

const Worksite = ({ filterWorkers, filter }) => {
  const [worksite, setWorksite] = useState([]);
  // const [selectedWorksites, setSelectedWorksites] = useState([]);

  const apiFunctions = {
    getWorkers: useCallback(() => {
      WorkService.get("/api/v1/worksite/get-worksite-data").then((res) => {
        setWorksite(res?.data?.data?.data || []);
      });
    }, []),
  };

  useEffect(() => {
    apiFunctions.getWorkers();
  }, []);

  // const handleCheckboxChange = (worksiteId) => {
  //   if (selectedWorksites.includes(worksiteId)) {
  //     setSelectedWorksites(selectedWorksites.filter((id) => id !== worksiteId));
  //   } else {
  //     setSelectedWorksites([...selectedWorksites, worksiteId]);
  //   }
  // };

  return (
    <div className=" bg-white p-30">
      {worksite.map((worksite, index) => (
        <div
          key={index}
          className="flex justify-between items-center border-b border-[#E8E8E8] py-2 fs-12"
        >
          {worksite?.name}
          <Checkbox
            onChange={() => filterWorkers("Worksite", worksite.id)}
            checked={filter.includes(worksite.id)}
          />
        </div>
      ))}
    </div>
  );
};

export default Worksite;
